export default __webpack_public_path__ + "static/media/glitch21.4ab2dffa.png";